import { useRecoilValue } from 'recoil'
import useRegularTable from '@/shared/Tables/Table/ctrl/useRegularTable.ts'
import Table from '@/shared/Tables/Table'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom.ts'
import equipmentTableFields from '@/pages/Equipment/components/Tables/EquipmentTable/equipmentTable.fields.tsx'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'
import EquipmentSidePage from '@/pages/Equipment/components/SidePages/EquipmentSidePage'
import { useMemo } from 'react'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import useIsAdmin from '@/pages/User/hooks/useIsAdmin'

interface IProps {
  search?: string
}

const EquipmentTable = (props: IProps) => {
  const isAdmin = useIsAdmin()

  const items = useRecoilValue(equipmentAtom).items
  const sidePageCtrl = useSidePageWithTableCtrl(items)

  const tableCtrl = useRegularTable({
    fields: isAdmin ? equipmentTableFields.admin : equipmentTableFields.user,
    tableKey: `equipment/items`,
    itemKey: 'id',
    items: items,
  })

  const filteredResults = useMemo(() => {
    if (!props.search) return tableCtrl.orderedItems

    const ls = props.search.toLowerCase()
    return tableCtrl.orderedItems.filter(
      (it) =>
        it.name.toLowerCase().includes(ls) ||
        it.description.toLowerCase().includes(ls) ||
        (it.location && equipmentUtils.getEquipmentAddress(it.location).toLowerCase().includes(ls))
    )
  }, [props.search, tableCtrl.orderedItems])

  return (
    <>
      <EquipmentSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        equipment={sidePageCtrl.selectedItem}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
      />
      <Table
        {...tableCtrl}
        onClick={sidePageCtrl.handleItemPageOpen}
        items={filteredResults as any}
        itemKey="id"
        loading={false}
      />
    </>
  )
}

export default EquipmentTable
